/*
 * HomeReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */

import produce from "immer";
import {
  LOADER_STATUS,
  PROFILE_INFO,
  SET_VARIANCE_DATA,
  SET_HSN_LIST,
  SET_GST_LIST,
  SET_RET_PERIOD,
  SET_VAULE_BY_TOP_HSN,
  SET_SPLY_VALUE_HSN,
  SET_HSN_VAULE_QTR,
  SET_SPLY_VALUE_RATIO,
  SET_CLEAR_GRAPH
} from "./constants";

// The initial state of the App
export const initialState = {
  loaderStatus: false,
  profileData: [],
  varianceData: [],
  GstListData: [],
  HsnListData: [],
  ReturnPeriodData: [],
  ValueByTopHsnData: [],
  hsnValueQtrData: [],
  splyValueByHsnData: [],
  splyValueRatioData: []
};

/* eslint-disable default-case, no-param-reassign */
const HSNAnalysisInwardReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus
      };
    case PROFILE_INFO:
      return {
        ...state,
        profileData: action.profileData
      };
    case SET_VARIANCE_DATA:
      return {
        ...state,
        varianceData: action.varianceData
      };
    case SET_GST_LIST:
      return {
        ...state,
        GstListData: action.GstListData
      };
    case SET_HSN_LIST:
      return {
        ...state,
        HsnListData: action.HsnListData
      };
    case SET_RET_PERIOD:
      return {
        ...state,
        ReturnPeriodData: action.ReturnPeriodData
      };
    case SET_VAULE_BY_TOP_HSN:
      return {
        ...state,
        ValueByTopHsnData: action.ValueByTopHsnData
      };
    case SET_HSN_VAULE_QTR:
      return {
        ...state,
        hsnValueQtrData: action.hsnValueQtrData
      };
    case SET_SPLY_VALUE_HSN:
      return {
        ...state,
        splyValueByHsnData: action.splyValueByHsnData
      };
    case SET_SPLY_VALUE_RATIO:
      return {
        ...state,
        splyValueRatioData: action.splyValueRatioData
      };
    case SET_CLEAR_GRAPH:
      return {
        ...state,
        splyValueRatioData: [],
        splyValueByHsnData: [],
        hsnValueQtrData: [],
        ValueByTopHsnData: [],
        ReturnPeriodData: [],
        HsnListData: [],
        GstListData: []
      };
    default:
      return state;
  }
};

export default HSNAnalysisInwardReducer;
